<template>
  <div>
    <div class="line"></div>
    <accordion show-divider
      :is-open="true"
    >
      <template v-slot:title>
        <div class="flex gap-3">
          <p class="font-bold">Independent Contractor Information</p>
        </div>
      </template>
      <div class="text-jet">
        <p class="text-base text-darkPurple font-bold">Residency Status</p>
        <div class="flex gap-3 my-3">
          <radio-button :options="residencyStatusOptions" class="inline-block" :disabled="true"
            v-model="employment.residencyStatus" row-gap="gap-y-1" space-between="mr-2"/>
        </div>

        <p class="text-base text-darkPurple font-bold">Contractor Type</p>
        <div class="flex gap-0 mt-3">
          <radio-button :options="contractorTypeOptions" class="inline-block" :disabled="true"
            v-model="employment.contractorType" row-gap="gap-y-0"/>
        </div>

        <div v-if="employment.contractorType === 'business'" class="w-full">
          <div class="line"></div>
          <p class="text-base text-darkPurple font-bold uppercase">
            business registration details
          </p>
          <div class="grid grid-cols-12 gap-6 text-darkPurple mt-3">
            <div class="col-span-3">
              <c-text placeholder="xxxxxxx" :disabled="true" label="Business Name" v-model="employment.businessName" />
            </div>
            <div class="col-span-3">
              <c-text placeholder="xxxxxxx" :disabled="true" label="Business Registration Number" v-model="employment.businessRegNumber" />
            </div>
            <div class="col-span-3 relative">
              <c-text placeholder="" :disabled="true" label="CAC Document"/>
              <FileUpload :file="CACDocumentfile"
                type="CACDocumentfile"
              />
            </div>
          </div>

          <div class="line"></div>
          <p class="text-base text-darkPurple font-bold uppercase">
            business Address
          </p>
          <div class="grid grid-cols-12 gap-6 text-darkPurple mt-3">
            <div class="col-span-3">
              <c-text placeholder="xxxxxxx" :disabled="true" label="Country" v-model="employment.businessCountry" />
            </div>
            <div class="col-span-3">
              <c-text placeholder="xxxxxxx" :disabled="true" label="State" v-model="employment.businessState" />
            </div>
            <div class="col-span-3">
              <c-text placeholder="xxxxxxx" :disabled="true" label="City" v-model="employment.businessCity" />
            </div>
            <div class="col-span-3">
              <c-text placeholder="xxxxxxx" :disabled="true" label="Address" v-model="employment.businessAddress" />
            </div>
            <div class="col-span-3">
              <c-text placeholder="xxxxxxx" :disabled="true" label="Postal Code" v-model="employment.businessPostalCode" />
            </div>
            <div class="col-span-3 relative">
              <c-text placeholder="" :disabled="true" label="Proof of Address" />
              <FileUpload :file="proofOfAddressFile"
                type="proofOfAddressFile"
              />
            </div>
          </div>
        </div>

        <div class="line"></div>

        <div class="w-full">
          <p class="text-base text-darkPurple font-bold uppercase">
            TAX Information
          </p>
          <div class="grid grid-cols-12 gap-6 text-darkPurple mt-3">
            <div class="col-span-3">
              <c-text placeholder="xxxxxxx" :disabled="true" label="Tax Identification Number" v-model="employment.taxIdentificationNumber" />
            </div>
            <div class="col-span-3 relative" v-if="employment.contractorType === 'business'">
              <c-text placeholder="" :disabled="true" label="Tax Clearance Certificate" />
              <FileUpload :file="taxCertFile"
                type="taxCertFile"

              />
            </div>
          </div>
        </div>

        <div class="line"></div>
      </div>
    </accordion>
  </div>
</template>

<script>
import Accordion from "@/components/Accordion";
import RadioButton from "@/components/RadioButton";
import CText from "@scelloo/cloudenly-ui/src/components/text";
import FileUpload from "./fileUpload";

export default {
  components: { Accordion, RadioButton, CText, FileUpload},
  name: "EmpIndContractor",
  props: {
    employment: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      isProofOfAddress: false,
      countrySelect: [],
      residencyStatusOptions: [
        {
          name: "Resident",
          radioName: "residency",
          value: "resident",
        },
        {
          name: "Non-Resident",
          radioName: "residency",
          value: "non-resident",
        },
      ],
      contractorTypeOptions: [
        {
          name: "Individual",
          radioName: "contractor",
          value: "individual",
        },
        {
          name: "Registered Business Name",
          radioName: "contractor",
          value: "business",
        },
      ],
      CACDocumentfile: [],
      proofOfAddressFile: [],
      taxCertFile: [],
    };
  },
  methods: {
    isValidFile(fileUrl, fileSize, fileType, fileName) {
      const isValid = fileUrl && fileSize && fileType && fileName

      return isValid
        ? [{
            fileUrl,
            fileSize,
            mimeType: fileType.split('/')[1],
            fileName
          }]
        : []
    }
  },
  mounted() {
    this.countrySelect = this.$store.state.countries.map((element) => ({
      id: element.Alpha3Code,
      name: element.Name,
    }));

    const { cacFileUrl, cacFileSize, cacFileType,  cacFileName,
      taxCertificateFileUrl, taxCertificateFileSize, taxCertificateFileType, taxCertificateFileName,
      businessProofOfAddress, businessProofOfAddressFileSize, businessProofOfAddressFileType, businessProofOfAddressFileName
    } = this.employment;

    this.CACDocumentfile = this.isValidFile(cacFileUrl, cacFileSize, cacFileType, cacFileName)
    this.proofOfAddressFile = this.isValidFile(businessProofOfAddress, businessProofOfAddressFileSize, businessProofOfAddressFileType, businessProofOfAddressFileName)
    this.taxCertFile = this.isValidFile(taxCertificateFileUrl, taxCertificateFileSize, taxCertificateFileType, taxCertificateFileName)
  }
};
</script>

<style scoped>
.line{
  border: 0.5px solid #00000029;
  width: 100%;
  height: 0;
  margin: 32px auto;
  border-radius: 10px;
  padding: 0;
}
</style>
